<template>
  <div class="row justify-content-center">
        <div class="col-12 col-lg-12">
          <h1 id="title" class="text-center mt-4">Rechercher un information <br> sur le site</h1>
        </div>
        <div class="col-12 col-lg-7">
          <div class="input-group search-input">
             <input @keyup="searchDebounce" v-model="searchText" type="text" placeholder="Votre recherche " class="search-input input-form">
          </div>
        </div>
        <div class="col-12 col-lg-7">
          <div v-if="noResult" >Aucun résultat ne corespond à votre recherche</div>
          <div v-if="showResults" class="search-results">
            <h3>Résutlat(s) de votre recherche</h3>
            <ul>
              <transition-group name="fade">
                <router-link
                  v-for="(item, index) in searchResults"
                  :key="index"
                  :to="item.router_link"
                  class="a-block">
                  <li class="z-depth-2" >
                      <div class="image"><img :src="item.img" alt=""></div>
                        <div class="content">
                          <div class="title">{{ item.title }}</div>
                      </div>
                  </li>
                </router-link>
              </transition-group>
            </ul>
          </div>
        </div>
      </div>
</template>
<script>
import api from '@/api'
import _ from 'lodash'
export default {
  data () {
    return {
      searchText: '',
      searchResults: [],
      showResults: false,
      noResult: false
    }
  },
  methods: {
    search () {
      let url = api.search + this.searchText
      this.axios.get(url)
        .then(response => {
          if (response.data.error) {
            this.showResults = false
            this.noResult = true
          } else {
            this.searchResults = []
            this.noResult = false
            this.showResults = true
            this.searchResults = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // Wait 0.3s when user is typing in search input
    searchDebounce: _.debounce(function () {
      this.searchResults = []
      // After waiting 0.3s do the search request
      this.search()
    }, 300)
  },
  mounted () {
    document.title = 'Recherche | ' + 'Komachi'
  }
}
</script>
<style lang="scss" scoped>
  @import 'Searchbar'
</style>



// WEBPACK FOOTER //
// src/components/Searchbar/Searchbar.vue